// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "55bc5c5072fe3ec0811b" + ".chunk.js";
};